import { useCallback, useMemo } from 'react';
import { Flag1LineIcon, Modal } from 'ui';
import { useReportContentObjectMutation } from '../queries';

export const useReportContentObjectModalConfirm = () => {
  const { mutateAsync: reportAsync } = useReportContentObjectMutation();
  const [modal, contextHolder] = Modal.useModal();

  const confirm = useCallback(
    ({ id, onSuccess, title }: { id: string; onSuccess: () => void; title: string }) => {
      modal.confirm({
        content: 'We will notify admins of your Organization',
        icon: <Flag1LineIcon type="info" />,
        okText: 'Report',
        async onOk() {
          await reportAsync(
            { id },
            {
              onSuccess,
            },
          );
        },
        title,
      });
    },
    [reportAsync, modal],
  );

  return useMemo(
    () => ({
      confirm,
      contextHolder,
    }),
    [confirm, contextHolder],
  );
};
